import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from '../views/Home.vue';
import About from '../views/About.vue';
import Contact from '../views/Contact.vue';
import Locations from '../views/Locations.vue';

import Menu from '../views/Menu.vue';
import Burgers from '../views/menus/Burgers.vue';
import BurgerBowls from '../views/menus/BurgerBowls.vue';
import Sandwiches from '../views/menus/Sandwiches.vue';
import HotDogs from '../views/menus/HotDogs.vue';
import Salads from '../views/menus/Salads.vue';
import Seafood from '../views/menus/Seafood.vue';
import Kids from '../views/menus/Kids.vue';
import Sides from '../views/menus/Sides.vue';
import Shakes from '../views/menus/Shakes.vue';
import Beverages from '../views/menus/Beverages.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/about', name: 'About', component: About },
  { path: '/contact', name: 'Contact', component: Contact },
  { path: '/locations', name: 'Locations', component: Locations },

  { path: '/menu', name: 'Menu', component: Menu },
  { path: '/menu/burgers', name: 'Burgers', component: Burgers },
  { path: '/menu/burger_bowls', name: 'BurgerBowls', component: BurgerBowls },
  { path: '/menu/sandwiches', name: 'Sandwiches', component: Sandwiches },
  { path: '/menu/hot_dogs', name: 'HotDogs', component: HotDogs },
  { path: '/menu/salads', name: 'Salads', component: Salads },
  { path: '/menu/seafood', name: 'Seafood', component: Seafood },
  { path: '/menu/kids', name: 'Kids', component: Kids },
  { path: '/menu/sides', name: 'Sides', component: Sides },
  { path: '/menu/shakes', name: 'Shakes', component: Shakes },
  { path: '/menu/beverages', name: 'Beverages', component: Beverages },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
